import { render, staticRenderFns } from "./SettingsContent.vue?vue&type=template&id=3acd51e1"
import script from "./SettingsContent.vue?vue&type=script&lang=ts"
export * from "./SettingsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports